import { render, staticRenderFns } from "./DiscountCustomers.vue?vue&type=template&id=b4991fd0&scoped=true"
import script from "./DiscountCustomers.vue?vue&type=script&lang=js"
export * from "./DiscountCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4991fd0",
  null
  
)

export default component.exports